import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroImpedimentos extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com impedimentos';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.impedimentos;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
